import React, { useState } from 'react';
import SimpleLoader from 'components/loader/SimpleLoader';
import SearchBar from 'components/search/SearchBar';
import StatusInfoTab from 'components/tabs/StatusInfoTab';
import useTableColumns from '../hooks/useTableColumns';
import { NTable } from '@innersource-nn/novoui-react';
import PaginationComponent from 'components/pager/Pagination';
import { SearchFilter } from 'types/Filters';

const tableHeaders = [
    { header: 'Name', key: 'name' },
    { header: 'Type', key: 'typeName' },
    { header: 'URI', key: 'columnUri' },
];

const TableColumns = () => {
    const [filter, setFilter] = useState<SearchFilter>({
        page: 1,
        pageSize: 10,
        term: '',
    });

    const { rows, error, loading, showSearchbar, items } =
        useTableColumns(filter);

    return (
        <div>
            <div>
                {showSearchbar && (
                    <SearchBar
                        term={filter.term ?? ''}
                        onTermChange={(e) => {
                            setFilter({ ...filter, term: e });
                        }}
                    />
                )}
                {error || rows.length === 0 ? (
                    <StatusInfoTab
                        child="columns"
                        parent="table"
                        error={error}
                    />
                ) : loading ? (
                    <SimpleLoader />
                ) : (
                    <div className="mt-16">
                        <NTable
                            headers={tableHeaders}
                            items={rows}
                            columnBorder={true}
                            rowKey="name"
                        />
                        <PaginationComponent
                            items={items}
                            filter={filter}
                            setFilter={setFilter}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default TableColumns;
